import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import VueCookie from 'vue-cookie'
import '@/element-ui'
import '@/element-ui-theme'
import '@/icons'
import '@/assets/scss/index.scss'
import httpRequest from '@/utils/httpRequest'
import httpRequest2 from '@/utils/httpRequest2'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)
import {
  isAuth,
  getDictValue,
  getSysDictVal,
  aesDecrypt,
  getLoginToken,
  manageOrgIdFlag,
  getDicts
} from '@/utils'
import plugins from './plugins'

Vue.use(VueCookie)
Vue.config.productionTip = false

Vue.use(plugins)

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$http2 = httpRequest2 // ajax请求方法
Vue.prototype.isAuth = isAuth     // 权限方法
Vue.prototype.getDictValue = getDictValue
Vue.prototype.getSysDictVal = getSysDictVal
Vue.prototype.getDicts = getDicts
Vue.prototype.aesDecrypt = aesDecrypt
Vue.prototype.getLoginToken = getLoginToken
Vue.prototype.manageOrgIdFlag = manageOrgIdFlag

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
